import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ClasificacionService {
    apiSiriUrl: string = environment.apiSiriUrl;
    constructor(private http: HttpClient) {}

    loadToxicologicalClassification(): Observable<any[]> {
        return this.http
            .get<
                any[]
            >(`${this.apiSiriUrl}tipo-producto/plaguicida-clasificacion-toxicologica`)
            .pipe(
                catchError((error) => {
                    console.error(
                        'Error al cargar la clasificación toxicológica:',
                        error
                    );
                    return throwError(
                        () =>
                            new Error(
                                'Error al obtener la clasificación toxicológica. Intente nuevamente más tarde.'
                            )
                    );
                })
            );
    }

    optClassification1(): Observable<any[]> {
        return this.http
            .get<
                any[]
            >(`${this.apiSiriUrl}tipo-producto/fertilizante-clasificacion-1`)
            .pipe(
                catchError((error) => {
                    console.error(
                        'Error al cargar la clasificación1 fertilizantes:',
                        error
                    );
                    return throwError(
                        () =>
                            new Error(
                                'Error al obtener la clasificación 1. Intente nuevamente más tarde.'
                            )
                    );
                })
            );
    }
}
